// src/utils/buildAuthUrl.js
import { auth } from '../config/firebaseConfig';
import { BACKEND_URL } from '../config/backendConfig';
import { getWorkspaceHeader } from '../config/workspaceHeader';

/**
 * Builds an authenticated URL for browser-native requests (img, audio, video, download links)
 * that can't go through axios. Appends a fresh auth_token and workspace_id as query params.
 */
export async function buildAuthUrl(path, params = {}) {
    const user = auth.currentUser;
    if (!user) throw new Error("Not authenticated");

    const token = await user.getIdToken(); // auto-refreshes if expired
    const workspaceId = getWorkspaceHeader();

    const query = new URLSearchParams({
        ...params,
        auth_token: token,
        ...(workspaceId && { workspace_id: workspaceId }),
    });

    return `${BACKEND_URL}${path}?${query.toString()}`;
}
